.content {
  max-height: calc(100% - 4rem);
}
